import QRCode from 'react-qr-code'
import { Text } from '@/components'
import AppStoreButton from '@/app/components/AppStoreButton/AppStoreButton'
import InnerCard from '@/components/InnerCard/InnerCard'
import Separator from '@/app/components/Separator/Separator'
import ConfigureDeviceStepBody from '../components/ConfigureDeviceStepBody'
import useConfigureMobilePushNotificationsViewModel from './ConfigureMobilePushNotifications.viewmodel'

export default function ConfigureMobilePushNotifications() {
  const { qrUrl } = useConfigureMobilePushNotificationsViewModel()

  return (
    <ConfigureDeviceStepBody>
      <div className="flex flex-col gap-6">
        <div className="flex flex-col gap-1">
          <Text variant="h2">Lastly, download our mobile app!</Text>
          <Text variant="body4" className="text-themed-grey-500">
            Download the app to receive up to date notifications on program
            events and the best Optiwatt experience
          </Text>
        </div>
        <InnerCard>
          <div className="flex flex-col items-center gap-4">
            <Text
              variant="body3"
              align="center"
              className="font-bold text-themed-grey-500"
            >
              Scan the QR code below to download the app.
            </Text>
            <div className="bg-white rounded-lg">
              <QRCode value={qrUrl} size={120} />
            </div>
            <Separator className="bg-themed-grey-200" />
            <div className="flex gap-2 w-full mt-4 justify-center">
              <AppStoreButton store="apple" className="flex-1 max-w-[130px]" />
              <AppStoreButton store="google" className="flex-1 max-w-[130px]" />
            </div>
          </div>
        </InnerCard>
      </div>
    </ConfigureDeviceStepBody>
  )
}
